var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import useSWR from 'swr';
import useAccessToken from './useAccessToken';
import { createLocation, deleteLocation, getLocationPermission, patchLocation, } from '../api/wrassets/apiClient';
export default function useLocations() {
    const { accessToken } = useAccessToken();
    const localStorageKey = 'locations-data';
    const cacheTimestampKey = 'locations-timestamp';
    const fetchWithLocalStorage = () => __awaiter(this, void 0, void 0, function* () {
        const cachedData = localStorage.getItem(localStorageKey);
        const cacheTimestamp = localStorage.getItem(cacheTimestampKey);
        if (cachedData && cacheTimestamp && Date.now() - parseInt(cacheTimestamp) < 10 * 1000) {
            return JSON.parse(cachedData);
        }
        const data = yield getLocationPermission(accessToken);
        // Store data in localStorage
        localStorage.setItem(localStorageKey, JSON.stringify(data));
        localStorage.setItem(cacheTimestampKey, Date.now().toString());
        return data;
    });
    const swrLocation = useSWR(accessToken ? 'locations' : null, fetchWithLocalStorage, {
        dedupingInterval: 10 * 1000, // Cache for 1 minute
        revalidateOnFocus: false, // Avoid refetching on window focus
        revalidateOnReconnect: false, // Avoid refetching on reconnect
        shouldRetryOnError: true, // Retry on errors
        errorRetryCount: 3, // Retry up to 3 times
    });
    const updateLocation = (location) => __awaiter(this, void 0, void 0, function* () {
        yield patchLocation({
            accessToken: accessToken,
            data: {
                phoneNumber: location.phoneNumber,
                name: location.name,
                address: location.address,
                locationId: location.id,
                connectId: location.connectId,
                details: Object.assign(Object.assign({}, location.details), { websiteDetails: Object.assign({}, location.details.websiteDetails), templates: Object.assign({}, location.details.templates), textTemplates: Object.assign({}, location.details.textTemplates) }),
            },
        });
        const data = yield getLocationPermission(accessToken);
        // Store data in localStorage
        localStorage.setItem(localStorageKey, JSON.stringify(data));
        localStorage.setItem(cacheTimestampKey, Date.now().toString());
        return data;
    });
    const addLocation = (location) => __awaiter(this, void 0, void 0, function* () {
        yield createLocation({
            accessToken: accessToken,
            data: {
                phoneNumber: location.phoneNumber,
                name: location.name,
                address: location.address,
                connectId: location.connectId,
                details: Object.assign(Object.assign({}, location.details), { websiteDetails: Object.assign({}, location.details.websiteDetails) }),
            },
        });
        const data = yield getLocationPermission(accessToken);
        // Store data in localStorage
        localStorage.setItem(localStorageKey, JSON.stringify(data));
        localStorage.setItem(cacheTimestampKey, Date.now().toString());
        return data;
    });
    const removeLocation = (locationId) => __awaiter(this, void 0, void 0, function* () {
        yield deleteLocation({
            accessToken: accessToken,
            data: { locationId },
        });
        const data = yield getLocationPermission(accessToken);
        // Store data in localStorage
        localStorage.setItem(localStorageKey, JSON.stringify(data));
        localStorage.setItem(cacheTimestampKey, Date.now().toString());
        window.location.reload();
        return data;
    });
    return Object.assign(Object.assign({}, swrLocation), { updateLocation, addLocation, removeLocation });
}
